export default "__VITE_ASSET__451052fa__"